import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Typography from '@ntuctech/devex-tangram/Typography';

const PageHeaderSC = styled.header`
  margin-bottom: 1.5rem;
`;

function PageHeader({ header }) {
  return (
    <>
      <PageHeaderSC>
        <Typography variant="h3" as="h1" className="ndsHidden-xs-down">
          {header}
        </Typography>
        <Typography variant="h5" as="h1" className="ndsHidden-s-up">
          {header}
        </Typography>
        <title>{`${header} - FairPrice Group`}</title>
      </PageHeaderSC>
    </>
  );
}

PageHeader.propTypes = {
  header: PropTypes.string.isRequired,
};

export default PageHeader;
